import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CartServiceService {
  constructor() {}
  length: any = 0;
  setLength(eraseNum: number = 0, sum?: string, btn?: boolean) {
    this.length = localStorage.getItem('contador');
    if(isNaN(this.length)){
      this.length = 0;
    }
    if (sum === 'sum' && !btn){
      this.length = Number(this.length) + eraseNum;
    }
    else if (sum === 'rest' && !btn){
      this.length = Number(this.length) - eraseNum;
    }

    if (sum === 'sum' && btn) {
      this.length++;
    } else if (sum === 'rest' && btn) {
      this.length--;
    }
    if(this.length > 0){
      localStorage.setItem('contador', this.length);
    }else{
      this.length = 0;
      localStorage.setItem('contador', '0');
    }
  }
}
